/*** IMPORTS FROM imports-loader ***/
(function() {


/**
 * Created by tford on 6/23/16
 */

/*
 * Non-friend Message Modal
 * Used when a user tries to send a message to a user that is not a friend
 */ 

define('fitbit-jquery-nonfriendMessageModal',['require','jquery'],function(require) {
    var $ = require("jquery");

    // Prevent duplicate initialization
    if ($.isFunction($.fn.nonfriendMessageModal)) {
        return;
    }

    /*
     * jQuery Plugin
     */
    $.fn.nonfriendMessageModal = function() {
        var $self = $(this);

        $self.overlay({
            top: '30%',
            mask: {
                maskId: 'nonfriend-message-mask',
                color: '#000'
            },
            close: ".cancel"
        });
        $self.data("overlay").load();
    };
});
}.call(window));


/** WEBPACK FOOTER **
 ** /home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts@2/catpack/~/imports-loader?this=>window!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts@2/catpack/web_loaders/requirejs-loader?{"config":{"entryPaths":["./js/fitbitui/nonfriendMessageModal.js"],"name":"fitbit-jquery-nonfriendMessageModal","exclude":["jquery"],"paths":{"shared/build/css/components/shared/styles","com/conf/webapp/common/resources/i18n/com/fitbit","core/core/i18n/src/main/resources/resources/i18n/com/fitbit"},"inlineText":true,"pragmasOnSave":{"excludeHbs":true,"excludeI18n":true}}}!./js/fitbitui/nonfriendMessageModal.js
 **/